import { gsap } from 'gsap';
import Observer from '../classes/Observer';
import WindowSize from '../singleton/WindowSize';

class Marquee extends Observer {
  $el: JQuery<HTMLElement>;
  width: number;
  speed: number;
  animation!: gsap.core.Tween;
  windowSize: WindowSize;

  constructor(el: HTMLElement) {
    super({
      isOnce: false
    });
    this.$el = $(el);
    this.width = this.$el.width()!;
    this.speed = this.width / 200;
    this.windowSize = WindowSize.getInstance();

    if(!this.$el.length || !this.observer) return;

    this.animation = gsap.fromTo(this.$el.get(0)!, {
      x: '-3.125%',
    }, {
      x: '-28.125%', // -25% - 3.125%%
      duration: this.speed,
      paused: true,
      ease: 'none',
      repeat: -1,
    });

    this.observer.observe(this.$el.get(0)!);

    this.windowSize.addListener(this.onResize.bind(this));
  }

  animateIn() {
    this.animation.play();
  }

  animateOut() {
    this.animation.pause();
  }

  onResize() {
    this.width = this.$el.width()!;
    this.speed = this.width / 200;
    this.animation.duration(this.speed);
  }
}

export default Marquee;
